module.exports = __webpack_public_path__ + "static/DMSans-BoldItalic-36ac160f0c12220b33f334793e09f3c8.woff2";